import React, { useState, useEffect } from 'react';
import { getHrisPengunduranDiri, getHrisPengunduranDiriById, createHrisPengunduranDiri, updateHrisPengunduranDiri, deleteHrisPengunduranDiri, getKaryawan } from '../../api';
import { Plus, Edit2, Trash2, LogOut, Search, Calendar, User } from 'lucide-react';

const JENIS_PENGUNDURAN = ['Mengundurkan Diri', 'PHK', 'Pensiun', 'Berakhir Kontrak'];
const STATUS_PENGUNDURAN = ['Menunggu', 'Diproses', 'Disetujui', 'Ditolak'];

const statusConfig = {
  'Menunggu': { bg: '#fef3c7', color: '#92400e', dot: '#fb6340' },
  'Diproses': { bg: '#eef9fd', color: '#0a66c2', dot: '#11cdef' },
  'Disetujui': { bg: '#d1fae5', color: '#065f46', dot: '#2dce89' },
  'Ditolak': { bg: '#fee2e2', color: '#991b1b', dot: '#f5365c' },
};

export default function HrisPengunduranDiri() {
  const [data, setData] = useState([]);
  const [karyawan, setKaryawan] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({
    karyawan_id: '', tgl_pengunduran: '', tgl_efektif: '', alasan: '',
    jenis_pengunduran: 'Mengundurkan Diri', no_surat: '', catatan: ''
  });

  const fetchData = () => {
    setLoading(true);
    Promise.all([getHrisPengunduranDiri(), getKaryawan()])
      .then(([dRes, kRes]) => { setData(dRes.data); setKaryawan(kRes.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchData(); }, []);

  const openCreate = () => {
    setEditing(null);
    setForm({ karyawan_id: '', tgl_pengunduran: '', tgl_efektif: '', alasan: '', jenis_pengunduran: 'Mengundurkan Diri', no_surat: '', catatan: '' });
    setShowModal(true);
  };

  const openEdit = async (id) => {
    try {
      const res = await getHrisPengunduranDiriById(id);
      const d = res.data;
      setEditing(d);
      setForm({
        karyawan_id: d.karyawan_id, tgl_pengunduran: d.tgl_pengunduran,
        tgl_efektif: d.tgl_efektif || '', alasan: d.alasan,
        jenis_pengunduran: d.jenis_pengunduran, no_surat: d.no_surat,
        catatan: d.catatan, status: d.status
      });
      setShowModal(true);
    } catch (e) { alert('Gagal memuat data'); }
  };

  const handleSubmit = async () => {
    if (!form.karyawan_id || !form.tgl_pengunduran) { alert('Lengkapi field wajib'); return; }
    try {
      if (editing) {
        await updateHrisPengunduranDiri(editing.id, form);
      } else {
        await createHrisPengunduranDiri(form);
      }
      setShowModal(false);
      fetchData();
    } catch (e) { alert('Gagal menyimpan'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Hapus data pengunduran diri ini?')) return;
    try { await deleteHrisPengunduranDiri(id); fetchData(); } catch (e) { alert('Gagal menghapus'); }
  };

  const totalData = data.length;
  const totalMenunggu = data.filter(d => d.status === 'Menunggu').length;
  const totalDisetujui = data.filter(d => d.status === 'Disetujui').length;
  const totalDiproses = data.filter(d => d.status === 'Diproses').length;

  const filtered = data.filter(d => {
    const matchSearch = !search || d.nama?.toLowerCase().includes(search.toLowerCase()) || (d.no_surat || '').toLowerCase().includes(search.toLowerCase());
    const matchStatus = !filterStatus || d.status === filterStatus;
    return matchSearch && matchStatus;
  });

  if (loading) return <div className="page-loading"><div className="spinner-lg" /></div>;

  return (
    <div className="page-container">
      <div className="page-header" style={{ borderBottom: '2px solid var(--gray-100)', paddingBottom: 16, marginBottom: 20 }}>
        <h2 style={{ fontSize: '1.35rem', fontWeight: 700, color: 'var(--gray-600)' }}>
          <LogOut size={22} style={{ marginRight: 8, verticalAlign: 'middle', color: 'var(--cyan-500)' }} />
          Data Pengunduran Diri
        </h2>
      </div>

      {/* Stat Cards */}
      {data.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 16, marginBottom: 20 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: '18px 20px', boxShadow: '0 0 2rem 0 rgba(136,152,170,0.15)', borderLeft: '4px solid var(--info)' }}>
            <div style={{ fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: 'var(--gray-400)', marginBottom: 4 }}>Total Pengajuan</div>
            <div style={{ fontSize: '1.75rem', fontWeight: 700, color: 'var(--gray-600)', lineHeight: 1.2 }}>{totalData}</div>
          </div>
          <div style={{ background: '#fff', borderRadius: 12, padding: '18px 20px', boxShadow: '0 0 2rem 0 rgba(136,152,170,0.15)', borderLeft: '4px solid #fb6340' }}>
            <div style={{ fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: 'var(--gray-400)', marginBottom: 4 }}>Menunggu</div>
            <div style={{ fontSize: '1.75rem', fontWeight: 700, color: '#92400e', lineHeight: 1.2 }}>{totalMenunggu}</div>
          </div>
          <div style={{ background: '#fff', borderRadius: 12, padding: '18px 20px', boxShadow: '0 0 2rem 0 rgba(136,152,170,0.15)', borderLeft: '4px solid #11cdef' }}>
            <div style={{ fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: 'var(--gray-400)', marginBottom: 4 }}>Diproses</div>
            <div style={{ fontSize: '1.75rem', fontWeight: 700, color: '#0a66c2', lineHeight: 1.2 }}>{totalDiproses}</div>
          </div>
          <div style={{ background: '#fff', borderRadius: 12, padding: '18px 20px', boxShadow: '0 0 2rem 0 rgba(136,152,170,0.15)', borderLeft: '4px solid #2dce89' }}>
            <div style={{ fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: 'var(--gray-400)', marginBottom: 4 }}>Disetujui</div>
            <div style={{ fontSize: '1.75rem', fontWeight: 700, color: '#065f46', lineHeight: 1.2 }}>{totalDisetujui}</div>
          </div>
        </div>
      )}

      {/* Toolbar */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20,
        padding: '12px 16px', background: '#fff', borderRadius: 12,
        boxShadow: '0 0 2rem 0 rgba(136,152,170,0.1)', flexWrap: 'wrap',
      }}>
        <button className="btn btn-primary" onClick={openCreate} style={{ whiteSpace: 'nowrap' }}>
          <Plus size={16} /> Tambah Pengunduran
        </button>
        <div style={{ flex: 1, minWidth: 200, maxWidth: 320 }}>
          <div className="search-box" style={{ width: '100%', margin: 0 }}>
            <Search size={16} />
            <input placeholder="Cari berdasarkan nama atau no. surat..." value={search} onChange={e => setSearch(e.target.value)} />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginLeft: 'auto' }}>
          <label style={{ fontSize: '0.78rem', color: 'var(--gray-400)', fontWeight: 500, whiteSpace: 'nowrap' }}>Status:</label>
          <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}
            className="form-select"
            style={{ width: 'auto', padding: '7px 12px', borderRadius: 8, border: '1px solid var(--gray-300)', fontSize: '0.82rem' }}>
            <option value="">Semua</option>
            {STATUS_PENGUNDURAN.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
          <span style={{ fontSize: '0.78rem', color: 'var(--gray-400)', whiteSpace: 'nowrap' }}>
            <strong style={{ color: 'var(--gray-600)' }}>{filtered.length}</strong>/{totalData}
          </span>
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="page-loading">Tidak ada data pengunduran diri</div>
      ) : (
        <div className="regions-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))' }}>
          {filtered.map(d => {
            const sc = statusConfig[d.status] || statusConfig['Menunggu'];
            return (
              <div key={d.id} className="region-card" style={{ borderTop: `3px solid ${sc.dot}` }}>
                <div className="region-card-header" style={{ background: '#fff', borderBottom: '1px solid var(--gray-100)', padding: '14px 16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1 }}>
                    <div style={{ width: 40, height: 40, borderRadius: 10, background: 'linear-gradient(135deg, #fb6340, #f5365c)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
                      <LogOut size={20} />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                        <h3 style={{ fontSize: '0.95rem', margin: 0, color: 'var(--gray-600)' }}>{d.nama}</h3>
                        <span style={{ fontSize: '0.65rem', padding: '2px 8px', borderRadius: 4, background: '#e6fafc', color: 'var(--cyan-700)', fontWeight: 500 }}>{d.jenis_pengunduran}</span>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 10px', borderRadius: 20, fontSize: '0.7rem', fontWeight: 600, background: sc.bg, color: sc.color }}>
                          <span style={{ width: 6, height: 6, borderRadius: '50%', background: sc.dot }} />
                          {d.status}
                        </span>
                      </div>
                      {d.no_surat && <div style={{ fontSize: '0.75rem', color: 'var(--gray-400)', marginTop: 2 }}>No. Surat: {d.no_surat}</div>}
                    </div>
                  </div>
                </div>
                <div className="region-card-body" style={{ padding: '12px 16px' }}>
                  <div className="region-detail"><Calendar size={14} className="text-muted" /><strong>Tgl. Pengunduran:</strong> {d.tgl_pengunduran}</div>
                  {d.tgl_efektif && <div className="region-detail"><Calendar size={14} className="text-muted" /><strong>Tgl. Efektif:</strong> {d.tgl_efektif}</div>}
                  {d.alasan && (
                    <div className="region-detail" style={{ borderTop: '1px solid var(--gray-100)', paddingTop: 8, marginTop: 8 }}>
                      <span style={{ color: 'var(--gray-500)', fontSize: '0.8rem', fontStyle: 'italic' }}>{d.alasan}</span>
                    </div>
                  )}
                  {d.catatan && (
                    <div className="region-detail" style={{ borderTop: '1px solid var(--gray-100)', paddingTop: 8, marginTop: 8 }}>
                      <User size={14} className="text-muted" />
                      <span style={{ color: 'var(--gray-500)', fontSize: '0.8rem' }}>{d.catatan}</span>
                    </div>
                  )}
                </div>
                <div className="action-btns" style={{ padding: '10px 16px', borderTop: '1px solid var(--gray-100)', justifyContent: 'flex-end' }}>
                  <button className="btn-icon" title="Edit" onClick={() => openEdit(d.id)}><Edit2 size={14} /></button>
                  <button className="btn-icon btn-danger" title="Hapus" onClick={() => handleDelete(d.id)}><Trash2 size={14} /></button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Form Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header" style={{
              background: 'linear-gradient(135deg, #fb6340 0%, #f5365c 100%)',
              margin: -1, padding: '20px 24px', borderRadius: 'var(--radius-lg) var(--radius-lg) 0 0',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12
            }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <LogOut size={18} color="white" />
              </div>
              <h3 style={{ color: 'white', fontSize: '1.1rem', fontWeight: 700, margin: 0 }}>{editing ? 'Edit Pengunduran Diri' : 'Tambah Pengunduran Diri'}</h3>
            </div>
            <div className="modal-body">
              <div style={{ background: 'var(--accent-tint-bg)', borderRadius: 'var(--radius)', border: '1px solid var(--cyan-100)', overflow: 'hidden' }}>
                <div style={{
                  padding: '12px 16px', borderBottom: '1px solid var(--cyan-100)',
                  background: 'rgba(255,255,255,0.6)',
                  fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase',
                  letterSpacing: '0.5px', color: 'var(--cyan-700)',
                  textAlign: 'center',
                }}>
                  <LogOut size={13} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                  Informasi Pengunduran Diri
                </div>
                <div style={{ padding: 16, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px 20px' }}>
                  <div className="form-group" style={{ margin: 0 }}>
                    <label>Karyawan <span style={{color:'var(--danger)'}}>*</span></label>
                    <select value={form.karyawan_id} onChange={e => setForm({...form, karyawan_id: parseInt(e.target.value)})} required>
                      <option value="">Pilih Karyawan</option>
                      {karyawan.map(k => <option key={k.id} value={k.id}>{k.nama}</option>)}
                    </select>
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    <label>Jenis Pengunduran <span style={{color:'var(--danger)'}}>*</span></label>
                    <select value={form.jenis_pengunduran} onChange={e => setForm({...form, jenis_pengunduran: e.target.value})}>
                      {JENIS_PENGUNDURAN.map(j => <option key={j} value={j}>{j}</option>)}
                    </select>
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    <label>Tgl. Pengunduran <span style={{color:'var(--danger)'}}>*</span></label>
                    <input type="date" value={form.tgl_pengunduran} onChange={e => setForm({...form, tgl_pengunduran: e.target.value})} required />
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    <label>Tgl. Efektif</label>
                    <input type="date" value={form.tgl_efektif} onChange={e => setForm({...form, tgl_efektif: e.target.value})} />
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    <label>No. Surat</label>
                    <input type="text" value={form.no_surat} onChange={e => setForm({...form, no_surat: e.target.value})} placeholder="Contoh: SK-001/2026" />
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    {editing ? (
                      <>
                        <label>Status</label>
                        <select value={form.status} onChange={e => setForm({...form, status: e.target.value})}>
                          {STATUS_PENGUNDURAN.map(s => <option key={s} value={s}>{s}</option>)}
                        </select>
                      </>
                    ) : (
                      <>
                        <label>Catatan</label>
                        <input type="text" value={form.catatan} onChange={e => setForm({...form, catatan: e.target.value})} placeholder="Opsional" />
                      </>
                    )}
                  </div>
                </div>
                <div style={{ padding: '0 16px 14px' }}>
                  <div className="form-group" style={{ margin: 0 }}>
                    <label>Alasan <span style={{color:'var(--danger)'}}>*</span></label>
                    <textarea value={form.alasan} onChange={e => setForm({...form, alasan: e.target.value})} rows={2} placeholder="Jelaskan alasan pengunduran diri..." style={{ fontSize: '0.82rem' }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setShowModal(false)}>Batal</button>
              <button className="btn btn-primary" onClick={handleSubmit}>{editing ? 'Simpan' : 'Tambah'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
